
export enum ColumnOrder {
    ASCENDING = 'asc',
    DESCENDING = 'desc'
}

export class SelectedSort {
    public sortBy : string;
    public sortDir : ColumnOrder;

    constructor(name : string, direction : ColumnOrder) {
        this.sortBy = name;
        this.sortDir = direction;
    }

}

export class ListColumn {

    public display : string = '';
    public sortName : string = '';
    public isSortable : boolean = false;
    public headerClass : string = '';

    /***
     *
     * @param name The display name of the column header
     * @param sortName The naame that will be appended to the
     *                  query when sorting by a column
     * @param sortable Whether the column should be click sortable
     * @param headerClass A class for the heading, such as table-cell-center to line it up with centered cells
     */
    constructor(name : string, sortName: string, sortable : boolean = false, headerClass : string = '') {
        this.display = name;
        this.sortName = sortName;
        this.isSortable = sortable;
        this.headerClass = headerClass;
    }

}
